<template>
    <div>
        <div class="container settings">
            <h3>{{ 'CHANGEPASSWORD' | translate }}</h3>
            <form action="/login" method="post" id="settings-form" v-on:submit.prevent>
                <div class="form-group">
                    <label for="password-oldpassword">{{ $t('CURRENTPASSWORD') }}</label>
                    <b-form-input v-model="password.oldPassword"
                                  type="password"
                                  id="password-oldpassword"
                                  :state="password.oldPassword.length > 0"
                    ></b-form-input>
                </div>
                <div class="form-group">
                    <label for="password-newpassword">{{ $t('NEWPASSWORD') }}</label>
                    <b-form-input v-model="password.newPassword"
                                  type="password"
                                  id="password-newpassword"
                                  :state="password.newPassword.length > 0"
                    ></b-form-input>
                </div>
                <div class="form-group">
                    <button class="btn btn-primary" type="submit" @click="changePassword">{{ 'SAVECHANGES' | translate }}</button>
                </div>
            </form>
            <div class="alert alert-danger" v-if="error !== false">{{ error | translate }}</div>
            <div class="alert alert-success" v-if="success !== false">{{ success | translate }}</div>
        </div>
    </div>
</template>

<script>
import AuthService from '../services/auth.service';

export default {
    name: 'settings',
    data() {
        let error   = false,
            success = false;
        return {
            password: {
                oldPassword: '',
                newPassword: ''
            },
            user: this.$store.state.game.user,
            error,
            success
        };
    },
    methods: {
        changePassword() {
            const auth = new AuthService();
            auth.changePassword(this.password)
                .then(res => {
                    this.success = 'PASSWORDCHANGEOK';
                    this.error = false;
                    this.password = {
                        oldPassword: '',
                        newPassword: ''
                    };
                })
                .catch(err => {
                    if (err.response.status === 403) {
                        this.success = false;
                        this.error = 'PASSWORDINCORRECT';
                    } else {
                        console.log('err.response.status:', err.response.status);
                        console.error('error caught@component: ', JSON.parse(JSON.stringify(err)), err);
                        if (err.response) {
                            console.error('response: ', err.response.data.message);
                            this.error = err.response.data.message;
                            return err.response;
                        }
                    }
                });
        }
    }
};
</script>

<style scoped>
h1, h2 {
    font-weight: normal;
}

ul {
    list-style-type: none;
    padding:         0;
}

li {
    display: inline-block;
    margin:  0 10px;
}

a {
    color: #42b983;
}
</style>
